import React from "react";
import { useLanguageSelection } from "../../hooks/use-language-selection";
import { useLanguage } from "../../hooks/use-language";

/**
 * Renderiza el selector de idioma de la aplicación.
 *
 * Permite al usuario alternar entre español e inglés. Al seleccionar un idioma,
 * actualiza el estado global mediante `useLanguageSelection` y almacena la
 * preferencia en `localStorage` para conservarla entre sesiones.
 *
 * @returns {JSX.Element} LanguageSwitcher
 */
export const LanguageSwitcher = () => {
    const languageSelection = useLanguageSelection();
    const language = useLanguage();

    const updateLanguage = (lang) => {
        languageSelection.setLanguage({lang});
        localStorage.setItem('language', lang);
    }

    return(
        <div className="d-flex language-switcher" data-lang={language}>
            <div className="language-switcher__indicator" />
            <button 
                className={`language-switcher-button focusable-red ${language === "es" ? "active-language-button": "" }`}
                onClick={() => updateLanguage("es")}
            >
                Español
            </button>
            <button 
                className={`language-switcher-button focusable-red ${language === "en" ? "active-language-button": "" }`}
                onClick={() => updateLanguage("en")}
            >
                English
            </button>
        </div>
    )
}